export const CurrentlyStudying = () => (
    <div className="flex h-full items-center justify-center">Currently Studying</div>
);
